import { useState, useEffect } from "react";

import { Typography, Grid, Button, Tab, Tabs, Paper, Box, } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { EventInterface } from "../../interfaces";
import { PlannerLayout } from "../../layouts";
import {
  getEventsCreated,
  getSelectedEvent,
  getSelectedEventAttendees,
} from "../../api/providers/plannerEventsProviders";
import { LoadingScreen } from "../../ui/components/LoadingScreen";
import {
  PlannerEventsTable, PlannerEventDetails, PlannerEventAttendees,
  PlannerEventTickets, PlannerEventCodeScanners, PlannerEventStats
} from "../../components/planner";


interface Event {
  id: number;
  name: string;
  category: {
    id: number;
    name: string;
  };
  startDate: string;
  endDate: string;
  isPublished: boolean;
  status: string;
}

export default Event;

interface BuyerInfo {
  id: number;
  name: string;
  email: string;
  phoneNumber: string;
  identification: string;
}

interface TicketHolder {
  id: number;
  name: string;
  email: string;
  identification: string;
}

interface TicketVariant {
  id: number;
  name: string;
}

interface EventAttendee {
  id: number;
  purchaseDate: string;
  used: boolean;
  buyerInfo: BuyerInfo;
  ticketHolder: TicketHolder;
  ticketVariant: TicketVariant;
}

export const EventsPage = () => {
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);
  const [events, setEvents] = useState<Event[]>([]);
  const [eventData, setEventData] = useState<EventInterface>();
  const [eventAttendees, setEventAttendees] = useState<EventAttendee[]>([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setisLoading] = useState(true);

  const [tabValue, setTabValue] = useState(1);

  const handleTabChange = (_event: unknown, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    allEventsCreated();
  }, []);

  useEffect(() => {
    selectedEventData();
    selectedEventDataAttendees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEvent]);

  const allEventsCreated = async () => {
    try {
      setLoading(true);
      const result = await getEventsCreated();
      if (result.ok) {
        setEvents(result.data);
      }
    } catch (error) {
      console.error("Error obteniendo los datos del usuario:", error);
    } finally {
      setLoading(false);
    }
  };

  const selectedEventData = async () => {
    try {
      setisLoading(true);
      if (selectedEvent && selectedEvent.id) {
        const result = await getSelectedEvent(selectedEvent.id);
        if (result.ok) {
          setEventData(result.data);
        }
      } else {
        console.log("nada");
      }
    } catch (error) {
      console.error("Error obteniendo los datos del usuario:", error);
    } finally {
      setisLoading(false);
    }
  };

  const selectedEventDataAttendees = async () => {
    try {
      setLoading(true);
      if (selectedEvent && selectedEvent.id) {
        const result = await getSelectedEventAttendees(selectedEvent.id);
        if (result.ok) {
          setEventAttendees(result.data);
        }
      } else {
        console.log("nada");
      }
    } catch (error) {
      console.error("Error obteniendo los datos del usuario:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PlannerLayout title="eventos">
      <Box sx={{ mb: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => (setSelectedEvent(null), setEventData(null))}
          sx={{ color: "primary.main", textDecoration: "underline" }}
        >
          Volver atrás
        </Button>

        <Typography
          fontSize={32}
          component="div"
          align="left"
        >
          {selectedEvent ? selectedEvent.name : "Todos los eventos"}
        </Typography>
      </Box>

      {loading || isLoading ? (
        <LoadingScreen />
      ) : selectedEvent ? (
        <Grid container direction="column">
          <Grid container>
            <Paper
              elevation={6}
              sx={{
                p: 2,
                width: "100%",
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
              }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                centered
                scrollButtons="auto"
              >
                <Tab label="ESTADISTICAS" />
                <Tab label="DETALLES" />
                <Tab label="ASISTENTES" />
                <Tab label="ENTRADAS" />
                <Tab label="CODE SCANNERS" />
                <Tab label="PROMOCODERS" />
              </Tabs>

              {tabValue === 0 && (
                <PlannerEventStats />
              )}
              {tabValue === 1 && (
                <PlannerEventDetails
                  setEventData={setEventData}
                  loading={loading}
                  setLoading={setLoading}
                  eventId={selectedEvent.id}
                  selectedEventData={selectedEventData}
                  eventData={eventData}
                />
              )}
              {tabValue === 2 && (
                <PlannerEventAttendees attendees={eventAttendees} />
              )}
              {tabValue === 3 && (
                <PlannerEventTickets
                  ticketVariants={eventData?.ticketVariants}
                  eventId={selectedEvent?.id}
                  selectedEventData={selectedEventData}
                />
              )}
              {tabValue === 4 && (
                <PlannerEventCodeScanners
                  ticketValidators={eventData?.ticketValidators}
                  eventId={selectedEvent?.id}
                  selectedEventData={selectedEventData}
                />
              )}
              {tabValue === 5 && (
                <Box>
                  <Typography variant="h6">
                    Contenido para la pestaña "PROMOCODERS"
                  </Typography>
                </Box>
              )}
            </Paper>
          </Grid>
        </Grid>
      ) : (
        <PlannerEventsTable events={events} selectEvent={setSelectedEvent} />
      )}
    </PlannerLayout>
  );
};
